import Cookies from "js-cookie"
import { APP_DOMAIN } from "@Platon/const"

export const cookie = Cookies.withAttributes({ APP_DOMAIN })
